import Router from 'vue-router'
import Home from '@/components/Home'
import Login from 'shared_ui_components/src/auth/Login'
import AuthCallback from 'shared_ui_components/src/auth/AuthCallback'

export default function createRouter ({authService}) {
  return new Router({
    routes: [
      {
        path: '/',
        name: 'Home',
        component: Home,
        beforeEnter: ensureAuthenticated
      },
      {
        path: '/login',
        name: 'LoginPage',
        component: Login,
        props: {appTitle: 'pulseData Application Suite'}
      },
      {
        path: '/access_token=:token',
        name: 'AuthCallback',
        component: AuthCallback
      },
      {
        path: '/error=:errormessage',
        name: 'AuthCallback',
        component: AuthCallback
      }
    ]
  })

  function ensureAuthenticated (to, from, next) {
    if (!authService.isAuthenticated()) {
      next('/login')
    } else {
      next()
    }
  }
}



// WEBPACK FOOTER //
// /src/router/index.js